import { render } from "./ItemSizeView.vue?vue&type=template&id=2bfd683f"
import script from "./ItemSizeView.vue?vue&type=script&lang=js"
export * from "./ItemSizeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__